<template>
  <div>
    <common-dialog
      ref="dialog"
      :width="isMB?'86%':'600px'"
      :title="text"
      :data="data"
      :save-func="()=>{}"
      @details-opened="onDetailsOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <div slot="form" class="my-form">
        <!-- <el-form-item label="流程名称">
          <span>{{data.ProcessName}}</span>
        </el-form-item>-->
        <div class="form-item">
          <div class="i-label">{{data.Title}}</div>
          <div class="i-value">
            <el-tag class="my-tag" style type="primary" v-if="data.InstanceStatus==1">审批中</el-tag>
            <el-tag class="my-tag" type="success" v-if="data.InstanceStatus==2">已通过</el-tag>
            <el-tag class="my-tag" type="danger" v-if="data.InstanceStatus==3">已驳回</el-tag>
            <el-tag class="my-tag" type="info" v-if="data.InstanceStatus==4">已撤销</el-tag>
            <el-tag class="my-tag" type="info" v-if="data.InstanceStatus==5">通过后撤销</el-tag>
            <el-tag class="my-tag" type="danger" v-if="data.InstanceStatus==6">异常</el-tag>
            <el-tag class="my-tag" type="info" v-if="data.InstanceNodeName">
              <span>{{data.InstanceNodeName}}</span>
            </el-tag>
            <el-tag class="my-tag" type="primary" v-if="data.Status==0">待办</el-tag>
            <el-tag class="my-tag" type="success" v-if="data.Status==1">已办</el-tag>
          </div>
        </div>
        <template v-for="(i,key) in data.FormItems">
          <template v-if="i.FuncType > 0">
            <template v-if="i.ComponentType==0&&i.ItemType==2">
              <div style="margin-left: 18px;" :key="key">
                <span :style="i.Options">{{i.Explain}}</span>
              </div>
            </template>
            <template v-else-if="i.ComponentType==1&&(i.ItemType==6||i.ItemType==7)"></template>
            <el-form-item :label="i.ItemName" :key="key" v-else>
              <!-- {{i.FormItemValue}} -->
              <!-- <template v-if="i.FuncType==2"> -->
              <div v-if="data.Node.NodeType==0">
                <autoitem
                  :ref="'autoitem_'+key"
                  :options="LeaveTypes"
                  :component-type="i.ComponentType"
                  :item-type="i.ItemType"
                  v-model="i.FormItemValue"
                  @change="onItemChange($event,i)"
                  :upload-data="{FormItemId:i.FormItemId}"
                />
              </div>
              <div v-else>
                <template v-if="i.ItemType==400">
                  <template v-for="(a,akey) in i.FormItemValue.split('--|--')">
                    <span class="attach" :key="akey" @click="download(a)">{{a.split('--@--')[1]}}</span>
                  </template>
                </template>
                <template v-else>
                  <span v-if="i.ItemName!='开始时间'&&i.ItemName!='结束时间'">
                    <span>{{i.FormItemValue}}</span>
                    <span v-if="i.ItemName=='请假时长'">天</span>
                  </span>
                  <span v-else>{{getDatePM(i)}}</span>
                </template>
              </div>
            </el-form-item>
          </template>
        </template>
        <el-form-item label="意见">
          <el-input type="textarea" v-model="data.Comment" placeholder="请输入内容"></el-input>
        </el-form-item>
        <div style="height: 5px;"></div>
        <div style="border-top: 1px solid #DCDFE6;margin: 3px 0;"></div>
        <div class="row-head">操作日志</div>
        <el-table :data="data.Logs" border>
          <el-table-column prop="NodeName" label="操作节点" show-overflow-tooltip></el-table-column>
          <el-table-column prop="EmpName" label="操作人" width="75"></el-table-column>
          <!-- <el-table-column prop="AddTime" label="审批时间" width="130"></el-table-column> -->
          <el-table-column prop="AddTime" label="操作时间" width="130">
            <template slot-scope="{row}">
              <span v-if="row.Direction==100"></span>
              <span v-else>{{row.AddTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Direction" label="操作结果" width="75">
            <template slot-scope="{row}">
              <span v-if="row.Direction==100">待审批</span>
              <template v-else>
                <!-- 审批：同意/驳回/撤销/转审 -->
                <span v-if="row.Direction==0">同意</span>
                <span v-if="row.Direction==1">驳回</span>
                <span v-if="row.Direction==2">撤销</span>
                <span v-if="row.Direction==3">转审</span>
                <span v-if="row.Direction==4">处理</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="Comment" label="操作意见" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <template slot="footer">
        <template v-if="data.NodeName=='异常处理'">
          <el-button type="primary" @click="onHandle">处 理</el-button>
        </template>
        <template v-else>
          <template v-if="data.Node.NodeType==0">
            <el-button type="primary" @click="onReSubmit">重新提交</el-button>
            <el-button type="danger" @click="onCancel">撤销申请</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="onAgree">同 意</el-button>
            <el-button type="danger" v-if="data.Node&&data.Node.RejectMode!=0" @click="onReject">驳 回</el-button>
          </template>
        </template>
        <el-button @click="close">取 消</el-button>
      </template>
      <handle-dialog ref="handleDialog" @handle-success="onClose" />
      <reject-dialog ref="rejectDialog" @close-saved="onClose" />
      <cancel-dialog ref="cancelDialog" @cancel-success="onClose" />
      <el-dialog title="查看图片" :width="isMB?'90%':''" :visible.sync="imgVisible" append-to-body>
        <img width="100%" :src="imgUrl" alt />
      </el-dialog>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import autoitem from "@/components/wf/common/index";
import handleDialog from "./handleDialog";
import rejectDialog from "./rejectDialog";
import cancelDialog from "./cancelDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    autoitem,
    handleDialog,
    rejectDialog,
    cancelDialog,
  },
  data() {
    return {
      text: "待办信息",
      data: {
        WorkId: null,
        ProcessId: "",
        ProcessName: "",
        InstanceId: null,
        InstanceStatus: 0,
        InstanceNodeName: "",
        Title: "",
        NodeId: "",
        NodeName: "",
        NodeType: 0,
        Comment: "", //意见
        FormItems: [],
        Logs: [],
        Node: {
          RejectMode: 0, //不能驳回/驳回至上一节点/驳回至申请人/审批人选择驳回节点
          VersionId: "",
          NodeType: null, //申请人/审批/抄送/条件分支 99流程结束
        },
        RejectNodes: [],
      },
      Processes: [],
      LeaveTypes: [],
      isMB: this.$store.state.isMB,
      api: require("@/api/wf/instance").default,
      leave_type_api: require("@/api/ent/leaveType").default,
      imgVisible: false,
      imgUrl: "",
    };
  },
  computed: {},
  methods: {
    onDetailsOpened(data) {
      console.log("action", JSON.parse(JSON.stringify(data)));

      this.api.getWorkInstance(data.WorkId).then((res) => {
        console.log("res", res);
        if (res.Data.Node) this.data.Node = { ...res.Data.Node };
        this.data.RejectNodes = res.Data.RejectNodes;
        this.data.Logs = res.Data.Logs;

        this.$nextTick(() => {
          this.data.FormItems.forEach((x, i) => {
            var value = x.FormItemValue;
            if (x.ItemType == 400) {
              value = x.FormItemValue.split("--|--");
            } else {
              if (x.ItemName == "开始时间" || x.ItemName == "结束时间") {
                var name = x.ItemName + "部分";
                var new_item = data.FormItems.find(
                  (item) => item.ItemName == name
                );
                value = {
                  value1: x.FormItemValue,
                  value2: new_item.FormItemValue,
                };
              }
              if (x.ItemType == 3) value = Number(x.FormItemValue);
            }
            // console.log(i, x.ItemName, value);
            if (x.FuncType > 0) {
              // if (x.FuncType == 2) this.$refs["autoitem_" + i][0].setData(value);
              if (this.data.NodeName == "申请人") {
                if (this.$refs["autoitem_" + i])
                  this.$refs["autoitem_" + i][0].setData(value);
              }
            }
          });
        });
      });
      this.leave_type_api.list({}).then((res) => {
        this.LeaveTypes = res.Data;
      });
    },
    getDatePM(i) {
      var name = i.ItemName + "部分";
      var item = this.data.FormItems.find((x) => x.ItemName == name);
      return i.FormItemValue + " " + item.FormItemValue;
    },
    onItemChange(data, row) {
      if (!data) return;
      console.log("item-change", row.ItemName, row.FormItemValue);
      console.log("data", JSON.parse(JSON.stringify(data)));
      if (row.ComponentType == 1 && row.ItemType == 0) {
        row.Scale = data.Scale;
      }
      if (row.ComponentType == 1 && (row.ItemType == 1 || row.ItemType == 2)) {
        // console.log("data", JSON.parse(JSON.stringify(data)));
        this.$nextTick(() => {
          var items = this.data.FormItems;
          var start = items.find((x) => x.ItemName == "开始时间");
          var end = items.find((x) => x.ItemName == "结束时间");
          var start_value = start.FormItemValue.split(" ");
          var end_value = end.FormItemValue.split(" ");
          console.log("date", start_value, end_value);

          var diff_day = 0;
          if (start_value[0] && end_value[0]) {
            var range = this.data.FormItems.find(
              (x) => x.ItemName == "请假时长"
            );
            var start_time = new Date(start_value[0]).getTime() / 1000;
            var end_time = new Date(end_value[0]).getTime() / 1000;
            diff_day = parseInt((end_time - start_time) / 60 / 60 / 24); //相差天数
            if (diff_day < 0) {
              this.$message({
                customClass: "my-msg",
                type: "warning",
                message: "开始时间必须小于结束时间",
              });
              range.FormItemValue = 0;
              return;
            }
            var svalue = start_value[1];
            var evalue = end_value[1];

            if (svalue && evalue) {
              if (svalue == "上午" && evalue == "上午") {
                if (diff_day == 0) range.FormItemValue = 0.5;
                else range.FormItemValue = diff_day + 0.5;
              }
              if (svalue == "下午" && (evalue == "下午" || evalue == "晚上")) {
                if (diff_day == 0) range.FormItemValue = 0.5;
                else range.FormItemValue = diff_day + 0.5;
              }
              if (svalue == "上午" && evalue == "下午") {
                if (diff_day == 0) range.FormItemValue = 1;
                else range.FormItemValue = diff_day + 1;
              }
              if (svalue == "上午" && evalue == "晚上") {
                if (diff_day == 0) range.FormItemValue = 1;
                else range.FormItemValue = diff_day + 1;
              }
              if (svalue == "晚上" && evalue == "晚上") {
                if (diff_day == 0) range.FormItemValue = 0.5;
                else range.FormItemValue = diff_day + 0.5;
              }
              if (svalue == "晚上" && evalue == "下午") {
                if (diff_day == 0) {
                  this.$message({
                    customClass: "my-msg",
                    type: "warning",
                    message: "开始时间必须小于结束时间",
                  });
                  range.FormItemValue = 0;
                  return;
                } else range.FormItemValue = diff_day + 0.5;
              }
              if ((svalue == "下午" || svalue == "晚上") && evalue == "上午") {
                if (diff_day == 0) {
                  this.$message({
                    customClass: "my-msg",
                    type: "warning",
                    message: "开始时间必须小于结束时间",
                  });
                  range.FormItemValue = 0;
                  return;
                } else range.FormItemValue = diff_day;
              }
              // console.log("计算", range.FormItemValue, diff_day);
            }
          }
        });
      }
    },
    onReSubmit() {
      this.$confirm("请沟通后修改或补充，仅限重新提交一次。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.onAgree();
        })
        .catch(() => {});
    },
    onCancel() {
      this.$refs.cancelDialog.openCreate({
        InstanceId: this.data.InstanceId,
        Comment: this.data.Comment,
      });
    },
    onAgree() {
      var data = { ...JSON.parse(JSON.stringify(this.data)) };
      var can_save = true;
      var err_msg = "";
      data.FormItems.forEach((x) => {
        if (x.IsRequired) {
          if (!x.FormItemValue) {
            can_save = false;
            err_msg += "<span>" + x.ItemName + "不能为空；</span><br />";
          }
          if (x.ItemName == "开始时间" || x.ItemName == "结束时间") {
            var value = x.FormItemValue.split(" ");
            if (value[1] == "") {
              can_save = false;
              err_msg += "<span>" + x.ItemName + "不能为空；</span><br />";
            } else {
              var item = data.FormItems.find(
                (i) => i.ItemName == x.ItemName + "部分"
              );
              item.FormItemValue = value[1];
              x.FormItemValue = value[0];
            }
          }
        }
      });
      console.log("save", JSON.parse(JSON.stringify(data)));
      if (!can_save) {
        this.$message({
          customClass: "my-msg",
          type: "warning",
          dangerouslyUseHTMLString: true,
          message: err_msg,
        });
        return;
      }
      // return;
      this.$refs.dialog.isLoading = true;
      this.api.agree(data).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message({
            customClass: "my-msg",
            type: "success",
            message: res.Msg,
          });
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message({
            customClass: "my-msg",
            type: "error",
            message: res.Msg,
          });
        }
      });
    },
    onReject() {
      var data = { WorkId: this.data.WorkId, Comment: this.data.Comment };
      console.log("reject", data);

      if (this.data.Node.RejectMode == 3) {
        data.RejectNodes = this.data.RejectNodes;
        this.$refs.rejectDialog.openCreate(data);
      } else {
        this.$refs.dialog.isLoading = true;
        this.api.reject(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message({
              customClass: "my-msg",
              type: "success",
              message: res.Msg,
            });
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message({
              customClass: "my-msg",
              type: "error",
              message: res.Msg,
            });
          }
        });
      }
    },
    onHandle() {
      this.$refs.handleDialog.openCreate({
        VersionId: this.data.Node.VersionId,
        WorkId: this.data.WorkId,
        Comment: this.data.Comment,
      });
    },
    onClose() {
      this.$emit("close-saved");
      this.close(true);
    },
    onClosed() {},
    download(item) {
      var url = item.split("--@--")[0];
      var name = item.split("--@--")[1];
      var ext_list = name.split(".");
      var ext = ext_list[ext_list.length - 1];
      console.log("name", name);
      console.log("ext", ext);

      if (ext == "jpg" || ext == "png" || ext == "jpeg") {
        this.imgUrl = location.protocol + "//" + location.host + "/api" + url;
        console.log("imgUrl", this.imgUrl);
        this.imgVisible = true;
        return;
      }
      if (ext == "pdf") {
        if (this.chrome) {
          var href = location.protocol + "//" + location.host + "/api" + url;
          window.open(href, "_blank");
          return;
        }
      }

      const elink = document.createElement("a");
      elink.download = name;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + url;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
  },
};
</script>
<style lang="scss" scoped>
.my-form {
  .form-item {
    display: flex;
    margin-left: 17px;
    line-height: 28px;
    margin-bottom: 5px !important;
  }
  .el-form-item {
    margin-bottom: 5px !important;
  }
  .attach {
    color: #409eff !important;
    cursor: pointer;
  }
  .attach:not(:last-child)::after {
    content: "、";
  }
  .my-tag {
    margin-left: 7px;
  }
  .my-tag + .my-tag {
    margin-left: 7px;
  }
}
</style>